<template>
  <div class="admin-page">
    <layout>
      <template v-slot:search>
        <div class="search-wrapper">
          <div class="title"><a-icon type="search" /> 数据筛选</div>
          <a-divider></a-divider>
          <a-space>
            <a-range-picker v-model="queryParam.date" />
            <a-input allow-clear placeholder="账号" v-model="queryParam.username" />
            <a-input allow-clear placeholder="姓名" v-model="queryParam.name" />
            <a-select show-search allow-clear placeholder="角色" v-model="queryParam.role_id"  option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in roles" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="状态" v-model="queryParam.enabled">
              <a-select-option :value="1">正常</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>
          </a-space>
        </div>
      </template>

      <template v-slot:content>
        <a-space class="table-operator">
          <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加</a-button>
          <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo('destroy')">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="destroy()"><a-icon type="delete" />删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /></a-button>
          </a-dropdown>
        </a-space>
        <a-table
          :columns="columns"
          :row-key="record => record.id"
          :data-source="data"
          :row-selection="{ onChange: onSelectChange }"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
        >
          <div slot="workers" slot-scope="workers">
            <span v-if="workers">
              <span v-for="item in workers" :key="item.id">
                {{item.username}}
              </span>
            </span>
            <span v-else> - </span>
          </div>
          <div slot="teams" slot-scope="teams">
            <span v-if="teams">
              <span v-for="item in teams" :key="item.id">
                {{item.name}}
              </span>
            </span>
            <span v-else> - </span>
          </div>
          <div slot="corporations" slot-scope="corporations">
            <span v-if="corporations">
              <span v-for="item in corporations" :key="item.id">
                {{item.name}}
              </span>
            </span>
            <span v-else> - </span>
          </div>
          <div slot="status" slot-scope="enabled">
            <a-tag :color="enabled ? 'green' : 'red'">
              {{ enabled ? '正常' : '禁用' }}
            </a-tag>
          </div>

          <div slot="online" slot-scope="record">
            <span v-if="record.online === 0">{{ record.online }}</span>
            <a v-else href="javascript:void(0);" @click="showOnline(record)">{{ record.online }}</a>
          </div>

          <div slot="action" slot-scope="record" class="actions">
            <template v-if="accessTo(['update', 'destroy'])">
              <a href="javascript:;" @click="create(record)" v-if="accessTo('update')">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认要删除吗?" @confirm="destroy(record)" v-if="accessTo('destroy')">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template v-else>-</template>
          </div>
        </a-table>
      </template>
    </layout>
    <create-form
      v-if="showForm"
      :showForm.sync="showForm"
      :model="model"
      @success="refresh"
    />
    <online-page
      v-if="showOnlinePage"
      :showOnlinePage.sync="showOnlinePage"
      :model="model"
      @success="refresh"
    />
  </div>
</template>

<style lang="less" scoped>
@import 'Admin';
</style>

<script>
import Admin from './Admin'
export default Admin
</script>
